import { render } from "./icon-themify.vue?vue&type=template&id=a6e9d548"
import script from "./icon-themify.vue?vue&type=script&lang=js"
export * from "./icon-themify.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__